import React, { useState } from "react";
import styled from "styled-components";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import OnePageHeader from "../header/OnePageHeader";

const Layout = ({ title, children }) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <Header title={title} isOpen={isOpen} setOpen={setOpen} />
      <Main>{children}</Main>
      <Footer isOpen={isOpen} setOpen={setOpen} />
    </>
  );
};

export default Layout;

const Main = styled.main`
  width: 100vw;
  padding: 0 0 8.6rem 0;
`;
